
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/links",
      function () {
        return require("private-next-pages/links.js");
      }
    ]);
  